import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Dinda',
    title: "An English Tutor",
    desciption:" Never stop learning for when we stop learning, we stop growing.",
    // image: 'https://raw.githubusercontent.com/PhantomScript/asset-container/main/developer-portfolio/landingImg.png',
    resumePdf: resume
}
